import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class ReportsInsOutsHeader extends PureComponent {
  static propTypes = {
    companyId: PropTypes.string.isRequired,
    handleExport: PropTypes.func.isRequired,
    handleExportPDF: PropTypes.func.isRequired,
    subcompanyId: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    canAdd: false,
  };

  handleExport = (e) => {
    e.preventDefault();
    this.props.handleExport();
  };

  handleExportPDF = (e) => {
    e.preventDefault();
    this.props.handleExportPDF(this.props.t);
  };

  render = () => {
    return (
      <Common.Header title={this.props.t('reports.ins_outs.title')}>
        {/* <div className="btn-group pull-right">
          <Common.Dropdown>
            <Common.DropdownElement onClick={this.handleExport}>
              <i className="fa fa-table mr-1" />
              {"  "}
              {this.props.t("actions.exportCSV")}
            </Common.DropdownElement>
            <Common.DropdownElement onClick={this.handleExportPDF}>
              <i className="fa fa-archive mr-1" />
              {"  "}
              {this.props.t("actions.exportPDF")}
            </Common.DropdownElement>
          </Common.Dropdown>
        </div> */}
      </Common.Header>
    );
  };
}

export default translate()(ReportsInsOutsHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/ins_outs/InsOutsReportHeader.js